import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-bag2-icon',
  templateUrl: './shopping-bag2.component.html'
})
export class ShoppingBag2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
